$(document).ready(function() {
    $(document).on('click', '.js_final-checkout', function(e) {
      e.preventDefault();
      let templateName = $('body').attr('data-template');
      let uidCounts = {};
      let hasSingleUid = false;
  
      $(".js-cart--item").each(function() {
        let uniqId = $(this).attr('data-uid');
        if (!uniqId || uniqId === "undefined" || uniqId === "null") return;
  
        uidCounts[uniqId] = (uidCounts[uniqId] || 0) + 1;
      });
  
      for (let uid in uidCounts) {
        if (uidCounts[uid] === 1) {
          hasSingleUid = true;
          break;
        }
      }
  
      if (hasSingleUid) {
        Swal.fire({
          icon: "error",
          title: "Något gick fel!",
          text: "lägg till produkten i varukorgen igen",
          width: "26em",
          customClass: "wrong-product-warning",
          confirmButtonText: "Ok"
        }).then(() => {
          // After the user sees the alert and closes it, clear the cart
          fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(response => {
            if (response.ok) {
              if (templateName === 'cart') {
                window.location = "/cart";
              } else {
                do_cart_refresh();
                $('.cartpopup').removeClass('activepopup');
                $('body').removeClass('scroll-hide');
              }
            }
          });
        });
  
      } else {
        // All uids are duplicates → proceed to checkout
        window.location = '/checkout';
      }
    });
  
  });